module.exports = __webpack_public_path__ + "img/mikrotik-badge-background.2989a785.jpeg";